export function defaultMemoResolver(...args: any[]): string {
  return args.map((value: any) => JSON.stringify(value)).toString();
}
